import { postReqAuth } from '../../api';

export const createChapter = (data, cb) =>
  postReqAuth('/webapi/institute/chapter/create', data, '', cb);

export const updateChapter = (data, cb) =>
  postReqAuth('/webapi/institute/chapter/update', data, '', cb);

export const deleteChapter = (data, cb) =>
  postReqAuth('/webapi/institute/chapter/delete', data, '', cb);
